import { withCompInfo } from '@wix/editor-elements-integrations'
import { SkypeCallButtonCSSVars, SkypeCallButtonDefinition } from './SkypeCallButton'

export const SKYPE_SIZES = {
	call: {
		small: { width: 38, height: 16 },
		medium: { width: 56, height: 24 },
		large: { width: 73, height: 32 },
	},
	chat: {
		small: { width: 45, height: 16 },
		medium: { width: 65, height: 24 },
		large: { width: 86, height: 32 },
	},
}

export const css = withCompInfo<SkypeCallButtonCSSVars, SkypeCallButtonDefinition>()(
	['compData', 'compProps'],
	({ compData, compProps }) => {
		const skypeButtonSize =
			SKYPE_SIZES[compData.buttonType] && SKYPE_SIZES[compData.buttonType][compProps.imageSize]
		const width = skypeButtonSize?.width
		const height = skypeButtonSize?.height
		const skypeColor = compProps.imageColor === 'white' ? 'trans_' : ''
		const backgroundImage = `url(https://secure.skypeassets.com/i/scom/images/skype-buttons/${compData.buttonType}button_${skypeColor}${height}px.png)`
		return {
			width: `${width}px`,
			height: `${height}px`,
			'--background-image': backgroundImage,
		}
	}
)
